import { initializeApp } from 'firebase/app';
import { initializeAuth, browserLocalPersistence, GoogleAuthProvider, OAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

let app = null;
let auth = null;
let db = null;
let analytics = null;

try {
  app = initializeApp(firebaseConfig);

  // Use browserLocalPersistence (localStorage) instead of the default
  // indexedDBLocalPersistence. IndexedDB hangs on iOS WKWebView with
  // the https://localhost origin that Capacitor uses, causing all auth
  // operations (signInWithEmailAndPassword, onAuthStateChanged) to
  // never resolve.
  auth = initializeAuth(app, {
    persistence: browserLocalPersistence,
  });

  db = getFirestore(app);
  console.info('[Firebase] Initialized successfully');
} catch (error) {
  console.error('[Firebase] Initialization failed:', error);
}

if (app && process.env.NODE_ENV === 'production') {
  try {
    analytics = getAnalytics(app);
  } catch (error) {
    console.warn('[Firebase] Analytics initialization failed:', error);
  }
}

const googleProvider = new GoogleAuthProvider();
const appleProvider = new OAuthProvider('apple.com');

export { auth, db, analytics, googleProvider, appleProvider };
export default app;
